import header from "./imports/header";
import glideSlider from "./imports/glide-slider";
// import AOSanimations from "./imports/aos-animations";
import accordion from "./imports/accordion";
// import resizeSpacer from "./imports/devider";
// import formOnOffer from "./imports/formOnOffer"
import plusMinusProduct from "./imports/plusMinusProduct";
// import navbarScroll from "./imports/header-scroll";
// import searchSidebarMobile from "./imports/searchSidebarMobile";
// import slideToggle from "./imports/slideToggle";
import wc from "./imports/wooCommerce";

document.addEventListener('DOMContentLoaded', () => {
    // header()
    glideSlider()
    // AOSanimations()
    accordion()
    // resizeSpacer()
    // formOnOffer()
    plusMinusProduct()
    // navbarScroll()
    // searchSidebarMobile()
    // slideToggle()
    wc()
}) 